export default class LoggerError extends Error {
  constructor(_ref) {
    let {
      name = '@locallife/log-js-error',
      error
    } = _ref;
    super();
    this.name = name;
    this.message = typeof error === 'string' ? error : error.message;
  }

}
//# sourceMappingURL=types.js.map